module.exports = __webpack_public_path__ + "static/media/candy-cane.e7af25f6.svg";